<span class="badge badge-lg badge-secondary rounded-lg shadow-sm"
  ><i-feather class="invert" name="calendar"></i-feather> {{ Service.messageLastDate | date: 'd MMMM y' }}</span
>
